import {Badge, BadgeBackground, Container,} from './BadgeSmall.styled';
import {StageColors} from '@models/BadgeColors';


interface IProps {
    badge:any,
    preview?:boolean,
}

const BadgeSmall = (props:IProps) => {
    return (
        <Container>
            <Badge hideBadge={props.preview} >
                <BadgeBackground colors={StageColors[props.badge.stage > StageColors.length - 1?StageColors.length - 1:props.badge.stage]}>
                </BadgeBackground>
                <props.badge.badgeImage />
            </Badge>
        </Container>
    );
}

export default BadgeSmall;